import lodashGet from 'lodash/get';
import { BRIDGE_RESPONSE_CODE } from '../interface/common';
import { api as masterApi } from '@/api/api';
import { isElectron, inWindow } from '@/config';
import bridgeProxyConfigList from '../config/config';
import { WorkerBridgeImpl as WebWorkerBridgeImpl } from '../webdriver/webWorkerEngine';
import { isSupportNativeProxy } from '@/api/util';
export class WorkerBridgeApi {
    constructor() {
        this.engine = null;
        this.systemApi = masterApi.getSystemApi();
        this.eventApi = masterApi.getEventApi();
        this.responseHandleMap = new Map();
        this.commonHandleMap = new Map();
        this.asyncExcuteCount = 0;
        this.lastPingTimestamp = Date.now();
        this.needReadyModuleNames = new Set(['mail', 'account']);
        this.taskLivenessCheckHandleMap = new Map();
        this.workerUnliveCount = 0;
        console.log('workerBridge.start');
    }
    async init() {
        if (!inWindow() || (window.isBridgeWorker !== true && window.isAccountBg !== true)) {
            return;
        }
        if (isElectron()) {
            this.engine = Object.assign(window.electronLib.workerBridgeManage, {
                broadcast2AllWin() { },
                addWinEvent() { },
                removeWinEvent() { },
            });
        }
        else {
            this.engine = new WebWorkerBridgeImpl();
        }
        this.initRegister();
        const eventId = this.eventApi.registerSysEventObserver('initModule', {
            name: 'initModule-workerBridge',
            func: (ev) => {
                const moduleName = ev.eventStrData;
                this.needReadyModuleNames.delete(moduleName);
                if (this.needReadyModuleNames.size === 0) {
                    this.eventApi.unregisterSysEventObserver('initModule', eventId);
                    this.startPullTask();
                    this.ping();
                    this.subAccountPageInnerEvents();
                    setTimeout(() => {
                        this.sendSubAccountReadyEvent();
                    }, 30);
                    this.startInspectWorkerbridgeAlive();
                }
            },
        });
    }
    scheduleInspectTask() {
        this.systemApi.intervalEvent({
            eventPeriod: 'short',
            handler: ev => {
                if (ev.seq % 5 !== 0 || ev.seq === 0) {
                    return;
                }
                this.checkTaskAlive();
            },
            seq: 0,
        });
    }
    subAccountPageInnerEvents() {
        this.eventApi.registerSysEventObserver('error', {
            func: ev => {
                console.warn('[accountPage-innerevent]', ev);
            },
        });
    }
    async sendSubAccountReadyEvent() {
        if (window && window.isAccountBg) {
            const mainAccount = this.systemApi.getMainAccount();
            const subAccount = this.systemApi.getCurrentSubAccount();
            const agentAccount = this.systemApi.getCurrentAgentAccount();
            const winInfo = await window.electronLib.windowManage.getCurWindow();
            this.eventApi.sendSysEvent({
                eventName: 'SubAccountWindowReady',
                eventData: {
                    mainAccount: mainAccount.email,
                    subAccount: subAccount.email,
                    winId: winInfo === null || winInfo === void 0 ? void 0 : winInfo.id,
                    webId: winInfo === null || winInfo === void 0 ? void 0 : winInfo.webId,
                    agentEmail: agentAccount.email,
                },
            });
        }
    }
    initRegister() {
        this.registerCommonCMD('common', async () => true);
        this.registerResponseCMD('common', 'thrownError', args => {
            throw new Error(args[0]);
        });
        this.registerResponseCMD('common', 'lookupWebId', async () => {
            if (isElectron()) {
                return window.electronLib.windowManage.getCurWindow();
            }
            return 'no-webid-inweb';
        });
        this.registerResponseCMD('common', 'sleep', () => new Promise(r => setTimeout(r, 100)));
        this.registerResponseCMD('common', 'longWait', () => new Promise(resolve => {
            setTimeout(resolve, 60 * 1000);
        }));
        this.registerResponseCMD('common', 'cacheImage', args => {
            const img = new Image();
            img.src = args[0];
            return Promise.resolve(true);
        });
        this.registerResponseCMD('common', 'forwardEvent', args => {
            if (Array.isArray(args) && args.length) {
                this.eventApi.sendSysEvent(args[0]);
            }
            return Promise.resolve(true);
        });
    }
    startPullTask(forcePullTask = false) {
        this.returnTaskResult({
            ackNo: `RESIDENT-TASK-${Math.random()}`,
            code: 0,
            data: undefined,
            errorMsg: 'ok',
            duration: [0],
        }, forcePullTask);
    }
    ping() {
        const account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        this.systemApi.intervalEvent({
            eventPeriod: 'mid',
            handler: () => {
                const now = Date.now();
                if (now - this.lastPingTimestamp < 10 * 1000) {
                    return;
                }
                this.engine.ping(account);
            },
            seq: 0,
        });
    }
    returnTaskResult(result, forcePullTask = false) {
        setTimeout(async () => {
            const enableCount = Math.max(WorkerBridgeApi.MaxEnableExcuteCount - this.asyncExcuteCount, 0);
            this.lastPingTimestamp = Date.now();
            const account = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
            try {
                const res = (await this.engine.returnTaskResult({
                    response: result,
                    options: {
                        count: enableCount,
                        type: 'bkStable',
                        account,
                        forcePullTask,
                    },
                }));
                this.doHandleTaskList(res);
            }
            catch (ex) {
                console.error('[pullTask]error:', ex);
                this.startPullTask();
            }
        }, 0);
        return Promise.resolve(true);
    }
    checkTaskAlive() {
        let deadTaskCount = 0;
        [...this.taskLivenessCheckHandleMap.keys()].forEach(seqNo => {
            const checkCount = this.taskLivenessCheckHandleMap.get(seqNo);
            if (checkCount > 0) {
                this.taskLivenessCheckHandleMap.set(seqNo, checkCount - 1);
            }
            else {
                deadTaskCount += 1;
                this.taskLivenessCheckHandleMap.delete(seqNo);
            }
        });
        if (deadTaskCount) {
            this.setAsyncExcuteCount(Math.min(this.asyncExcuteCount + deadTaskCount, WorkerBridgeApi.MaxEnableExcuteCount));
            this.startPullTask(true);
        }
    }
    async doHandleTaskList(list) {
        const startTime = Date.now();
        (Array.isArray(list) ? list : []).forEach(async (item) => {
            this.taskLivenessCheckHandleMap.set(item.seqNo, this.getTaskRespondCheckCount(item.requestContent.namespace, item.requestContent.apiname));
            try {
                this.setAsyncExcuteCount(this.asyncExcuteCount + 1);
                const result = await this.handleRequest(item);
                const endTime = Date.now();
                this.setAsyncExcuteCount(this.asyncExcuteCount - 1, false);
                return this.returnTaskResult({
                    code: BRIDGE_RESPONSE_CODE.SUCCESS,
                    data: result,
                    errorMsg: 'ok',
                    ackNo: item.seqNo,
                    duration: [endTime - startTime],
                });
            }
            catch (ex) {
                const errMsg = ex instanceof Error ? ex.message : ex;
                this.setAsyncExcuteCount(this.asyncExcuteCount - 1, false);
                return this.returnTaskResult({
                    code: errMsg === 'un-register-handle' ? BRIDGE_RESPONSE_CODE.API_UNREGISTER : BRIDGE_RESPONSE_CODE.API_RESPONSE_ERROR,
                    errorMsg: errMsg,
                    ackNo: item.seqNo,
                });
            }
            finally {
                this.taskLivenessCheckHandleMap.delete(item.seqNo);
            }
        });
        return true;
    }
    startInspectWorkerbridgeAlive() {
        this.systemApi.intervalEvent({
            eventPeriod: 'mid',
            handler: () => {
                if (this.workerUnliveCount >= 4) {
                    this.startPullTask(true);
                    this.workerUnliveCount = 0;
                    return;
                }
                this.workerUnliveCount += 1;
            },
            seq: 0,
        });
    }
    setAsyncExcuteCount(count, isResetUnliveCount = true) {
        if (isResetUnliveCount) {
            this.workerUnliveCount = 0;
        }
        this.asyncExcuteCount = count;
    }
    getTaskRespondCheckCount(namespace, apiname) {
        const defaultCount = (30 * 1000) / (5 * 1000);
        const bridgeProxyConfig = bridgeProxyConfigList.find(item => item.namespace === namespace);
        if (!bridgeProxyConfig) {
            return defaultCount;
        }
        const moduleTimeoutDuration = lodashGet(bridgeProxyConfig, 'priorityConfig[1]', 0);
        const apiconfig = bridgeProxyConfig.apis.filter(item => typeof item !== 'string').find(item => item.key === apiname);
        const apiTimeoutDuration = lodashGet(apiconfig, 'priorityConfig[1]', 0);
        if (typeof apiTimeoutDuration === 'number' && apiTimeoutDuration !== 0) {
            const count = apiTimeoutDuration / (5 * 1000);
            return Math.ceil(count);
        }
        if (typeof moduleTimeoutDuration === 'number' && moduleTimeoutDuration !== 0) {
            const count = moduleTimeoutDuration / (5 * 1000);
            return Math.ceil(count);
        }
        return defaultCount;
    }
    async handleRequest(params) {
        const { namespace, apiname, args } = params.requestContent;
        if (this.responseHandleMap.has([namespace, apiname].join('.'))) {
            const func = this.responseHandleMap.get([namespace, apiname].join('.'));
            return func(args);
        }
        if (this.commonHandleMap.has(namespace)) {
            const func = this.commonHandleMap.get(namespace);
            return func(apiname, args);
        }
        return Promise.reject(new Error('un-register-handle'));
    }
    async registerCommonCMD(namespace, handler) {
        this.commonHandleMap.set(namespace, handler);
    }
    async registerResponseCMD(namespace, cmd, handler) {
        this.responseHandleMap.set([namespace, cmd].join('.'), handler);
    }
    broadcast2AllWin(eventName, params) {
        if (isElectron()) {
            return;
        }
        this.engine.broadcast2AllWin(eventName, params);
    }
    addWinEvent(eventName, callback) {
        if (isElectron()) {
            return;
        }
        this.engine.addWinEvent(eventName, callback);
    }
    removeWinEvent(eventName, eventId) {
        if (isElectron()) {
            return;
        }
        this.engine.removeWinEvent(eventName, eventId);
    }
}
WorkerBridgeApi.MaxEnableExcuteCount = 10;
export const workerBridgeInstance = isSupportNativeProxy ? new WorkerBridgeApi() : null;
